import { render, staticRenderFns } from "./CelebrationDetails.vue?vue&type=template&id=371d08d8"
import script from "./CelebrationDetails.vue?vue&type=script&lang=js"
export * from "./CelebrationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports